import { usePublicLanguage } from "../../context/PublicLanguage";
import React from "react";
import { Link } from "react-router-dom";
import { articleLanguage, articlePath } from "../../lib/articleLanguage";
import { categoryLabel } from "@/components/CategoryTag";

export default function Trending({ items = [], mode = "editors_picks", isLoading = false, isError = false }) {
  const { t, language } = usePublicLanguage();
  return (
    <div>
      <div className="flex items-center gap-2.5 mb-5">
        <span className="font-display font-bold tracking-tight text-white text-lg">{t(mode === 'trending' ? 'Trending' : "Editor's Picks")}</span>
        <span className="td-eyebrow" style={{ color: "#71767c", fontSize: "0.58rem" }}>{t(mode === 'trending' ? 'Most read' : 'Recent stories')}</span>
      </div>
      <ol className="space-y-4">
        {!items.length && <li className="text-sm text-[#A7ABB0]" role="status">{t(isLoading ? 'Loading…' : isError ? 'Stories unavailable. Please try again.' : 'No published stories yet.')}</li>}
        {items.slice(0, 5).map((item, i) => {
          const selected = articleLanguage(item, language);
          const a = selected.article;
          return (
          <li key={a.slug} data-testid={`trending-${a.slug}`}>
            <Link to={articlePath(a, selected.language)} className="group flex gap-4 items-start">
              <span
                className="font-display font-extrabold leading-none shrink-0"
                style={{ color: "#FF8A1F", fontSize: "1.75rem", width: "2.2rem", opacity: 0.9 }}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="pt-0.5">
                <div className="td-eyebrow mb-1" style={{ color: "#71767c", fontSize: "0.56rem" }}>
                  {categoryLabel(a.category, language)}
                </div>
                <h4 lang={selected.language} className="font-display font-semibold text-white leading-snug text-[0.95rem] group-hover:text-[#FF8A1F] transition-colors">
                  {a.headline}
                </h4>
                {language === 'id' && selected.language === 'en' && <p className="text-xs text-[#FFB347] mt-1">English · Terjemahan belum tersedia</p>}
              </div>
            </Link>
          </li>
        ); })}
      </ol>
    </div>
  );
}
